import { Injectable } from '@angular/core';

import { LocalStorageValue } from '@app/common/models/LocalStorageValueModel';
import { LocalStorageEnum } from '@enums/LocalStorageEnum';
import { SettingsConfigItemModel } from '@models/SettingsConfigItemModel';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  setItem(prop: string, value: LocalStorageValue): void {
    localStorage.setItem(prop, JSON.stringify(value));
  }

  getItem(prop: string): LocalStorageValue {
    return JSON.parse(localStorage.getItem(prop));
  }

  removeItem(prop: string): void {
    localStorage.removeItem(prop);
  }

  clear(): void {
    localStorage.clear();
  }

  getToken(): string {
    return this.getItem(LocalStorageEnum.TOKEN_KEY) as string;
  }

  getRefreshToken(): string {
    return this.getItem(LocalStorageEnum.REFRESHTOKEN_KEY) as string;
  }

  setToken(token: string): void {
    this.setItem(LocalStorageEnum.TOKEN_KEY, token);
  }

  setRefreshToken(refreshToken: string): void {
    this.setItem(LocalStorageEnum.REFRESHTOKEN_KEY, refreshToken);
  }

  logOut(): void {
    this.removeItem(LocalStorageEnum.TOKEN_KEY);
    this.removeItem(LocalStorageEnum.REFRESHTOKEN_KEY);
    this.removeItem(LocalStorageEnum.ROLE);
  }

  getSettingsConfig(): SettingsConfigItemModel[] {
    return this.getItem(LocalStorageEnum.SETTINGS) as SettingsConfigItemModel[];
  }

  setSettingsConfig(config: SettingsConfigItemModel[]): void {
    this.setItem(LocalStorageEnum.SETTINGS, config);
  }

  getHash(): string {
    return this.getItem(LocalStorageEnum.HASH) as string;
  }

  setHash(hash: string): void {
    this.setItem(LocalStorageEnum.HASH, hash);
  }

  getChildWindowIds(): string {
    return this.getItem(LocalStorageEnum.CHILD_WINDOWS_IDS) as string;
  }

  setChildWindowIds(childWindowsIds: string): void {
    this.setItem(LocalStorageEnum.CHILD_WINDOWS_IDS, childWindowsIds);
  }

  removeChildWindowIds(): void {
    this.removeItem(LocalStorageEnum.CHILD_WINDOWS_IDS);
  }

  setTenantType(tenantType): void {
    this.setItem(LocalStorageEnum.TENANT_TYPE, tenantType);
  }

  getTenantType(): LocalStorageValue {
    return this.getItem(LocalStorageEnum.TENANT_TYPE);
  }

  removeTenantType(): void {
    this.removeItem(LocalStorageEnum.TENANT_TYPE);
  }
}
